import React, { useEffect, useState } from "react";

import { getFullPath } from "../Header/Header";
import { useAtom } from "jotai";
import { activeChildDetail, appConstants } from "../../../AtomStore/store";
import { CctvLink, DashboardLink, GalleryLink, SupportLink } from "./styles";
import timelineLogo from "../../../assets/timeline.png";
import { Device } from "@capacitor/device";

import defaultImage from "../../../assets/left-nico.png";

import { Link } from "react-router-dom";

const BottomPanel = () => {
  const [activeChild] = useAtom(activeChildDetail);
  const [constants] = useAtom(appConstants);
  const [isIOS, setIsIOS] = useState(false);
  const photo = activeChild?.childPhoto;

  const [, setBgImage] = useState(
    photo ? getFullPath(constants, photo) : defaultImage
  );

  useEffect(() => {
    const checkDevice = async () => {
      const info = await Device.getInfo();
      setIsIOS(info.platform === "ios");
    };
    checkDevice();
  }, []);

  useEffect(() => {
    if (!photo) {
      setBgImage(defaultImage);
      return;
    }

    const img = new Image();
    img.src = getFullPath(constants, photo);

    img.onload = () => {
      setBgImage(getFullPath(constants, photo)); // If the image loads successfully
    };

    img.onerror = () => {
      setBgImage(defaultImage);
    };
  }, [photo, constants]);

  const location = window.location.pathname;

  return (
    // <div className={`bottom-panel pt-2 ${isIOS ? "pb-[1.5rem]" : "pb-2"}`}>
    <div className={`bottom-panel pt-2 pb-2`}>
      <DashboardLink location={location} />
      <CctvLink location={location} />

      {/* <div>
        <MiddleLink
          location={location}
          img={bgImage} 
        />
      </div> */}
      <Link
        to="/timeline"
        className={`p-[10px] border-2 rounded-full   ${
          location === "/timeline" ? "border-header" : "border-black"
        }`}
      >
        {/* <svg
          xmlns="http://www.w3.org/2000/svg"
          className="border-2 rounded-full p-2 border-header"
          width="3em"
          height="3em"
          viewBox="0 0 48 48"
        >
          <path
            fill="#3f51b5"
            d="M42 29H20.8c-.5 0-1-.2-1.4-.6l-3.7-3.7c-.4-.4-.4-1 0-1.4l3.7-3.7c.4-.4.9-.6 1.4-.6H42c.6 0 1 .4 1 1v8c0 .6-.4 1-1 1"
          />
          <path fill="#cfd8dc" d="M9 6h2v36H9z" />
          <g fill="#90a4ae">
            <circle cx="10" cy="10" r="3" />
            <circle cx="10" cy="24" r="3" />
            <circle cx="10" cy="38" r="3" />
          </g>
          <path
            fill="#448aff"
            d="M34 43H20.8c-.5 0-1-.2-1.4-.6l-3.7-3.7c-.4-.4-.4-1 0-1.4l3.7-3.7c.4-.4.9-.6 1.4-.6H34c.6 0 1 .4 1 1v8c0 .6-.4 1-1 1"
          />
          <path
            fill="#00bcd4"
            d="M35 15H20.8c-.5 0-1-.2-1.4-.6l-3.7-3.7c-.4-.4-.4-1 0-1.4l3.7-3.7c.4-.4.9-.6 1.4-.6H35c.6 0 1 .4 1 1v8c0 .6-.4 1-1 1"
          />
        </svg> */}
        <img src={timelineLogo} className="size-6"></img>
      </Link>

      {/* <Link className='text-3xl font-thin text-center' to="/support" >
      <RiTimeLine className='text-black'/>
      
      </Link> */}

      <GalleryLink location={location} />

      <SupportLink location={location} />
    </div>
  );
};

export default BottomPanel;
